import React from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { Input, Text } from "../../Kit";
import { useForm } from "react-hook-form";
import { Button } from "../../Kit/Button";
import { usePostReferralCode } from "../../../Store/modules/ai/postReferralCode/postReferralCode";
import { useModal } from "../../../Store/modules/modal/modal";

export type ReferralCodeForm = {
  referral_code: string;
};
export const ReferralCodeModal: React.FC = () => {
  const { register, handleSubmit, watch } = useForm<ReferralCodeForm>();
  const { dispatchPostReferralCode, postReferralCodeLoading } = usePostReferralCode();
  const { dispatchCloseModal } = useModal();
  const onSubmit = (data: ReferralCodeForm) => {
    dispatchPostReferralCode(data);
  };
  const onSkip = () => {
    window.location.reload();
  };
  return (
    <Modal
      modalName={ModalNames.ReferralCodeModal}
      modalClassName="w-[296px]"
      ignorePadding
      preventToClose
      showCloseIcon
      onCloseAction={onSkip}
    >
      <div className="py-[30px] px-[20px]">
        <div className="flex items-center flex-col">
          <Text elementType="span" className="text-base" fontWeight={500}>
            referralCode.welcome
          </Text>
          <Text
            elementType="span"
            className="text-sm text-center px-[24px] mt-[10px]"
            fontWeight={400}
            color="textNotActive"
          >
            referralCode.description
          </Text>
        </div>
        <div className="mt-[16px]">
          <Text elementType="span" className="text-base" fontWeight={500}>
            referralCode.referralCode
          </Text>
          <Input
            name="referral_code"
            register={register}
            className="h-[41px] mt-2"
            placeholder="referralCode.enterReferralCode"
          />
        </div>
        <div className="mt-[24px] flex justify-between">
          <Button
            title="referralCode.confirmCode"
            className="w-[168px] h-[35px]"
            disabled={!watch().referral_code}
            bg="primary"
            onClick={handleSubmit(onSubmit)}
            loading={postReferralCodeLoading}
          />
          <Button
            onClick={onSkip}
            title="referralCode.skip"
            className="w-[76px] h-[35px]"
            bg="transparent"
            textColor="primary"
            borderColor="primary"
            borderWidth="1px"
            borderStyle="solid"
            textClassName="text-sm"
          />
        </div>
      </div>
    </Modal>
  );
};
